import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService";

const keyTargets = [
  {
    id: 1,
    title: "KEY 1",
    isBack: false,
  },
  {
    id: 2,
    title: "KEY 2",
    isBack: true,
  },
  {
    id: 3,
    title: "KEY 3",
    isBack: true,
  },
  {
    id: 4,
    title: "KEY 4",
    isBack: true,
  },
];

const Key4Modal = ({ isOpen, onClose }) => {
  const textAreaRef = useRef();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [inputs, setInputs] = useState({});
  const [currentDate, setCurrentDate] = useState(new Date());
  const [id, setId] = useState("")

  const handleInputChange = (e) => {
    setInputs({
      ...inputs,
      [currentIndex]: e.target.value,
    });
  };

  useEffect(() => {
    if (isOpen) {
      const textArea = textAreaRef.current;
      if (textArea) {
        textArea.focus();
        const length = textArea.value.length;
        textArea.setSelectionRange(length, length);
      }
    }
  }, [currentIndex, isOpen]);

  const sendKey4 = async () => {
    const completed_inputs = Object.values(inputs).filter((input) =>
      Array.isArray(input)
        ? input[0].trim().length > 0
        : input.trim().length > 0
    );
    const key_progress =
      (Number(completed_inputs.length) / Number(keyTargets.length)) * 100;

    const payload = {
      key1: inputs[0] || "",
      key2: inputs[1] || "",
      key3: inputs[2] || "",
      key4: inputs[3] || "",
      progress: key_progress,
      date: currentDate,
      _id: id
    };

    try {
      const res = await apiServiceHandler("POST", "api/key4/update", payload);
      if (res.status) {
        toastr.success(res.message);
        onClose();
        setInputs({});
      }
    } catch (error) {

    }
  };

  const handleNext = (e) => {
    e.preventDefault();

    if (!inputs[currentIndex]) {
      toastr.error("Please fill the input field");
      return;
    }

    if (currentIndex === keyTargets.length - 1) {
      sendKey4();
    }
    setCurrentIndex((prevIndex) =>
      prevIndex < keyTargets.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const handleBack = (e) => {
    e.preventDefault();
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const skipStep = (e) => {
    e.preventDefault();

    if (currentIndex === keyTargets.length - 1) {
      sendKey4();
    }

    setCurrentIndex((prevIndex) =>
      prevIndex < keyTargets.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  useEffect(() => {
    setCurrentIndex(0)
    const fetchData = async () => {
      const payload = {
        data: currentDate,
      };

      try {
        const res = await apiServiceHandler("POST", "api/key4/fetch", payload);
        if (res.status && res.data) {
          setInputs({
            0: res.data[0].key1 || "",
            1: res.data[0].key2 || "",
            2: res.data[0].key3 || "",
            3: res.data[0].key4 || "",
          });
          setId(res.data[0]._id)
        }
      } catch (error) {
        console.log("Failed to fetch data");
      }
    };

    fetchData();
  }, [isOpen]);

  return (
    <Modal show={isOpen} onHide={onClose} centered className="next90-modal">
      <Modal.Header
        closeButton
        style={{
          borderBottom: "none",
          backgroundColor: "#26262f",
          color: "#d1b794",
        }}
      >
        <Modal.Title style={{ fontWeight: "400" }}>KEY4</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#26262f" }}>
        <div
          className="edit-key"
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          <h4 style={{ fontWeight: "lighter", color: "#fff" }}>
            {keyTargets[currentIndex]?.title}
          </h4>
          <textarea
            type="text"
            className="credo-input"
            placeholder={currentIndex === 0 ? "Add your new Key 1 task for this next week" : ""}
            ref={textAreaRef}
            value={inputs[currentIndex] || ""}
            onChange={handleInputChange}
            style={{
              marginBottom: "1rem",
              border: "1px solid #d1b794",
              width: "100%",
              minHeight: "100px",
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          borderTop: "none",
          paddingTop: "1rem",
          backgroundColor: "#26262f",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <button
            type="button"
            className="save-next90-btn"
            onClick={handleBack}
            style={
              keyTargets[currentIndex].isBack
                ? { display: "block" }
                : { display: "none" }
            }
          >
            <span className="driver-button__label">BACK</span>
          </button>
          <button
            type="button"
            className="save-next90-btn"
            onClick={handleNext}
          >
            <span className="driver-button__label">SAVE</span>
          </button>
          {currentIndex !== keyTargets.length - 1 && (
            <button
              type="button"
              className="more-btn"
              onClick={skipStep}
            >
              <span className="more-button__label" >NEXT</span>
            </button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default Key4Modal;
